module.exports = __webpack_public_path__ + "img/coupon.73c5108a.png";